import account from '@/router/account' // 所有登录页
import { getBaseUrl } from '@/utils/common'
// import Vue from 'vue'

/**
 * 分页请求方法
 * 第一页的数据由newAjax或javaAjax获取
 * @param queryParams(object)；newAjax或javaAjax方法处理过的请求参数
 * @param firstRes(object)：newAjax或javaAjax方法获取的第一页分页数据
 * @param pageDataKey(string)：接口返回的分页数据的key，默认值为"Table1"，其它值可能有"Rows","dtData","data","Table"等
 * @param type(number)：1.newAjax请求接口触发分页  2.javaAjax请求触发分页
 */
window.$.pageAjax = function (
  queryParams,
  firstRes,
  pageDataKey = 'Table1',
  type = 1
) {
  const { successArguments, completeArguments } = queryParams
  delete queryParams.successArguments
  delete queryParams.completeArguments
  let LQProgress: any = null;
  if (!firstRes.success || !firstRes.data || typeof firstRes.data !== 'object') {
    // 执行success和complete回调函数的传参arguments
    callback(successArguments)
    return
  }
  firstRes.data.page = firstRes.data.page || 1
  const firstPageData = firstRes.data // 第一页的数据
  let page = Number(firstPageData.page) // 页号
  const pages = Number(firstPageData.pages) || 0 // 总页数
  const size = (top as any).PARAPAGESIZE || 5000 // 每页行数
  // const total = Number(firstPageData.total) || 0; // 总行数，暂时还用不上
  const maxRequestNum = (top as any).MAXREQUESTNUN || 6 // 最大同时并行请求接口数，暂定为6
  const isNeedShowProgress = (pages - page) > maxRequestNum  // 是否需要显示进度条
  let dataList = [firstPageData] // 并行请求分页接口的数据列表
  let paramsTemplete = {}
  let errorCode = '' // 请求失败的状态码
  for (let key of Object.keys(queryParams)) {
    if (typeof queryParams[key] !== 'function') {
      paramsTemplete[key] = JSON.parse(JSON.stringify(queryParams[key])) // 深拷贝，防止数据被污染
    }
  }

  // parallelRequest()
  createdRequestQueue()

  // 创建请求队列
  function createdRequestQueue() {
    let requestQueue: any = [] // 请求的队列
    let requestCount = pages - page // 需要请求的数量
    let requestNum = 0 // 正在请求的数量
    let isError = false // 存在请求失败的接口
    let successNum = 0 // 请求成功的数量
    if (requestCount <= 0) {
      callback(getSuccessResult())
      return
    }

    if (isNeedShowProgress) {
      LQProgress = window.VM.$LQProgress({ percentage: Math.floor(page / pages * 100), type: 'line' })
    }

    for (let i = 1; i <= requestCount; i++) {
      let params = JSON.parse(JSON.stringify(paramsTemplete)) // 深拷贝，防止数据被污染
      try {
        params.data = JSON.parse(params.data) || {}
      } catch (error) {
        params.data = {}
      }
      if (params.data.p && typeof params.data.p === 'object') {
        params.data.p.page = page + i
        params.data.p.size = size
        params.data.p.pageMinID = firstRes.data.pageMinID
        params.data.p.pageMaxID = firstRes.data.pageMaxID
      } else {
        params.data.p = {
          page: page + i,
          size: size,
          pageMinID: firstRes.data.pageMinID,
          pageMaxID: firstRes.data.pageMaxID
        }
      }
      params.data = JSON.stringify(params.data)
      requestQueue.push(params)
    }
    queueRequest()

    // 队列请求（按最大数量线程池）
    async function queueRequest() {
      const { length } = requestQueue
      if (requestCount <= 0 || isError) {
        return
      }
      request(requestQueue[length - requestCount])
        .then(() => {
          successNum++
          LQProgress && LQProgress.update(successNum === length ? 100 : Math.floor((page + successNum) / pages * 100))
          if (successNum === length) {
            callback(getSuccessResult())
            return
          }
          requestNum--
          if (requestNum < maxRequestNum) {
            queueRequest()
          }
        })
        .catch((message) => {
          isError = true
          callback(getErrorResult(message))
        })
      requestNum++
      requestCount--
      if (requestNum < maxRequestNum) {
        await sleep(30) // 等待30ms，尽量不要同时请求，隔开一点时间
        queueRequest()
      }
    }

    function sleep(interval) {
      return new Promise((resolve) => {
        setTimeout(resolve, interval)
      })
    }
  }

  // 并行请求（按最大数量）
  // function parallelRequest() {
  //   let requestList: any = []
  //   let tempMaxRequestNum = maxRequestNum
  //   if (pages - page < maxRequestNum) {
  //     tempMaxRequestNum = pages - page
  //     if (tempMaxRequestNum <= 0) {
  //       callback(getSuccessResult())
  //       return
  //     }
  //   }
  //   for (let i = 1; i <= tempMaxRequestNum; i++) {
  //     let params = JSON.parse(JSON.stringify(paramsTemplete)) // 深拷贝，防止数据被污染
  //     try {
  //       params.data = JSON.parse(params.data) || {}
  //     } catch (error) {
  //       params.data = {}
  //     }
  //     if (params.data.p && typeof params.data.p === 'object') {
  //       params.data.p.page = page + i
  //       params.data.p.size = size
  //       params.data.p.pageMinID = firstRes.data.pageMinID
  //       params.data.p.pageMaxID = firstRes.data.pageMaxID
  //     } else {
  //       params.data.p = {
  //         page: page + i,
  //         size: size,
  //         pageMinID: firstRes.data.pageMinID,
  //         pageMaxID: firstRes.data.pageMaxID
  //       }
  //     }
  //     params.data = JSON.stringify(params.data)
  //     requestList.push(request(params))
  //   }
  //   Promise.all(requestList)
  //     .then(() => {
  //       page += requestList.length
  //       parallelRequest()
  //     })
  //     .catch((message) => {
  //       callback(getErrorResult(message))
  //     })
  // }

  function request(params) {
    return new Promise((resolve, reject) => {
      const currentPage = JSON.parse(params.data).p.page
      params.success = function (res) {
        if (
          res.success &&
          res.data &&
          typeof res.data === 'object' &&
          Array.isArray(res.data[pageDataKey])
        ) {
          res.data.page = res.data.page || currentPage
          dataList.push(res.data)
          return resolve(res.data)
        } else {
          errorCode = res.code
          return reject(`第${currentPage}页请求数据异常`)
        }
      }
      params.error = function () {
        errorCode = '50000'
        return reject(`第${currentPage}页请求网络异常`)
      }
      window.$.ajax(params)
    })
  }

  function getSuccessResult() {
    let argumentList = [...successArguments]
    let mergeData = [] // 按分页顺序合并后的分页数据
    argumentList.shift()
    dataList
      .sort((a, b) => a.page - b.page)
      .forEach((item) => {
        mergeData = mergeData.concat(item[pageDataKey])
      })
    if (queryParams.dataIsArray) {
      firstRes.data = mergeData
    } else {
      firstRes.data[pageDataKey] = mergeData
    }
    argumentList.unshift(firstRes)
    return argumentList
  }

  function getErrorResult(message) {
    let result: any = {}
    result.code = errorCode
    result.success = false
    result.errmsg = `${message}，请稍后再试！`
    if (queryParams.dataIsArray) {
      result.data = []
    } else {
      result.data = {}
      result.data[pageDataKey] = []
    }
    if (type == 1) {
      result.Success = result.success
      result.state = result.success
      result.msg = result.errmsg
      result.errormsg = result.errmsg
      result.ErrMsg = result.errmsg
    }
    return [result]
  }

  function callback(result) {
    // 完成分页后，需要把在data上赋值的一些参数删除了，防止污染原始data
    // delete queryParams.data.page
    delete queryParams.data.size
    delete queryParams.data.pagingRequestID
    queryParams.isPageLoaded = true // 标记分页数据已加载完毕
    queryParams.success.apply(queryParams, result)
    queryParams.complete.apply(queryParams, completeArguments)
    if (LQProgress) {
      setTimeout(() => {
        LQProgress.close()
        LQProgress = null; // 赋值为null，垃圾回收机制优化
      }, 500)
    }
  }
}

// processName如果是调过程接口分页，return返回的值可以直接当做过程名，当做分页接口调用
// processName如果是调用java接口分页，return返回值，只能当做Boolean类型进行判断，是否开启分页
window.$.getPagePortByProcessName = function (processName, otherData = {}) {
  let whetherPage = false
  window.$.javaAjax({
    url: '/system-setting/v2/query',
    data: { processName, ...otherData },
    procParams: {
      M: 'func',
      N: processName
    },
    async: false,
    isNotCompare: true,
    useCustomError: true,
    timeout: 5000,
    success(res) {
      if (res.success && res.data) {
        whetherPage = res.data.whetherPage || false
      }
    }
  })
  return whetherPage ? `${processName.replace(/_PAGE$/i, '')}_PAGE` : ''
}

// 是否开启隐式分页
window.$.getPagePort = function (opt) {
  const pagePortList = (top as any).pagePortList || {}
  let result = false
  let page: any = null
  let path = ''
  const isInterfaceMethod =
    !opt.url ||
    (typeof opt.url === 'string' && /\/TmsApi\/InterfaceMethod/i.test(opt.url))

  if (
    isInterfaceMethod &&
    opt.procParams &&
    opt.procParams.N &&
    typeof opt.procParams.N === 'string'
  ) {
    opt.procParams = JSON.parse(JSON.stringify(opt.procParams)) // 深拷贝，防止污染页面定义的procParams字段
    path = (window as any).chineseToPinyin(opt.procParams.N).toLowerCase()
  }
  if (!isInterfaceMethod && opt.url && typeof opt.url === 'string') {
    path = opt.url.replace(/^\/web\//, '/').toLowerCase()
  }

  page =
    pagePortList[path] &&
    pagePortList[path].find(
      (item) =>
        !item.otherData ||
        !item.otherDataKey ||
        item.otherDataKey
          .split(',')
          .every((key) => item.otherData[key] == opt.data[key])
    )

  if (page) {
    if (typeof page.processName === 'undefined') {
      // 从未获取过该配置，需要调用接口，并缓存结果
      page.processName = window.$.getPagePortByProcessName(
        page.key,
        page.otherData
      )
    }
    if (page.processName) {
      if (isInterfaceMethod) {
        opt.procParams.N = page.processCName || page.processName // 调用过程名触发分页，过程名，需要替换
        if (opt.isSearchApp) {
          opt.isSearchApp = false // 调用过程，触发隐式分页，需要使用/lanqiao-tms-app路径
          opt.isSearchChangeApp = true // 记录/lanqiao-tms-search-app->/lanqiao-tms-app的标识
        }
      }

      // 分页接口请求需要传 page 和 size 字段
      opt.data.page = 1
      opt.data.size = (top as any).PARAPAGESIZE || 5000
      opt.data.pagingRequestID = (window as any).getGuid()
      opt.pageDataKey = page.pageDataKey
      opt.dataIsArray = Boolean(page.dataIsArray)
    }
    result = Boolean(page.processName)
  }
  return result
}

// 初始化隐式分页配置
window.$.getPagePortList = function () {
  const pathname = location.pathname.replace(getBaseUrl(), '')
  const pathnameList = [
    '/loadpage',
    '/loadpage/index', // 加载页
    '/account',
    ...account.map((item) => item.path) // 登录页
  ]
  if (
    (top as any).pagePortList ||
    pathnameList.some((item) => item.toLowerCase() === pathname.toLowerCase())
  ) {
    return
  }
  const pagePortList = {}
    ;[
      {
        path: 'qsp_get_back_total', // 财务中心-回单总账，必传
        key: 'QSP_GET_BACK_TOTAL', // 调用/system-setting/v2/query接口需要传的processName参数，必传
        pageDataKey: 'Table1', // 原来的接口，列表所对应的key，必传
        otherData: {}, // 调用/system-setting/v2/query接口额外需要的传参，非必传
        otherDataKey: '', // 额外参数，需要比较的key，支持多个以逗号隔开，满足条件，才会触发分页，非必传
        dataIsArray: false // 原来的接口，data的数据类型是否为数组，默认false，若为true需要和接口那边协商pageDataKey的字段值，非必传
      },
      {
        path: '/ForPayment/GetNowaccData', // 财务中心-结款核销-回单月结
        key: 'F9_QSP_GET_HX_LOAD_ACCBACK_ACCMONTH_PAGE',
        pageDataKey: 'Rows',
        otherData: { type: '回单月结' },
        otherDataKey: 'type'
      },
      {
        path: '/ForPayment/GetNowaccData', // 财务中心-结款核销-现付
        key: 'F9_QSP_GET_HX_LOAD_ACCNOW_PAGE',
        pageDataKey: 'Rows',
        otherData: { type: '现付' },
        otherDataKey: 'type'
      },
      {
        path: '/ForPayment/GetNowaccData', // 财务中心-结款核销-提付
        key: 'F9_QSP_GET_HX_LOAD_ACCARRIVED_PAGE',
        pageDataKey: 'Rows',
        otherData: { type: '提付' },
        otherDataKey: 'type'
      },
      {
        path: '/reportTpl/getDataCommon', // 财务中心-运单大全
        key: 'QSP_ALL_PAGE',
        pageDataKey: 'Rows',
        otherData: { type: '运单大全' },
        otherDataKey: 'type'
      },
      {
        path: '/cashDayAccount/cashDayAccount_Index', // 财务中心-现金日记账
        key: 'F9_QSP_GET_CN_LIST_PAGE',
        pageDataKey: 'griddata',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: 'qsp_get_web_order', // 资金账户-交易记录
        key: 'QSP_GET_WEB_ORDER_PAGE',
        pageDataKey: 'Table1',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/reportTpl/getDataCommon', // 财务中心-发车明细报表
        key: 'QSP_GET_FCD_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: { type: '发车明细报表' },
        otherDataKey: 'type'
      },
      {
        path: '/financialReconciliation/customerReconciliation_F9', // 财务中心-客户对账
        key: 'F9_QSP_CUSTOMER_COUNT_MAIN_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/DeliveryRecord/ModifyGetinventory', // 营运中心-送货上门
        key: 'QSP_GET_SEND_LOAD_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: 'qsp_get_back_one', // 回单管理-回单寄出
        key: 'QSP_GET_BACK_ONE_PAGE',
        pageDataKey: 'Table1',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/writeOffDetailed/detailedIndex', // 财务中心-核销明细-现付
        key: 'F9_QSP_GET_HX_LIST_ACCNOW_PAGE',
        pageDataKey: 'Rows',
        otherData: { xm: '现付' },
        otherDataKey: 'xm'
      },
      {
        path: '/writeOffDetailed/detailedIndex', // 财务中心-核销明细-提付
        key: 'F9_QSP_GET_HX_LIST_ACCARRIVED_PAGE',
        pageDataKey: 'Rows',
        otherData: { xm: '提付' },
        otherDataKey: 'xm'
      },
      {
        path: '/writeOffDetailed/detailedIndex', // 财务中心-核销明细-回单月结
        key: 'F9_QSP_GET_HX_LIST_ACCBACK_ACCMONTH_PAGE',
        pageDataKey: 'Rows',
        otherData: { xm: '回单月结' },
        otherDataKey: 'xm'
      },
      {
        path: '/cashier/cashierAuditing', // 财务中心-出纳审核
        key: 'F9_QSP_GET_CN_CHECK_LOAD_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: 'sanbaopaidanjilu_andan_sb', // 三包管理-三包派单
        key: 'QSP_GET_THREE_GURANTEE_RECORD_PAGE',
        pageDataKey: 'Table1',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/changeClassReport/getOperRecord', // 财务中心-操作日志报表
        key: 'QSP_GET_CANCEL_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: 'qsp_get_shipper_khzl', // 客服中心-客户资料-发货人
        key: 'QSP_GET_SHIPPER_KHZL_PAGE',
        pageDataKey: 'Table1',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: 'qsp_get_consignee_ex', // 客服中心-客户资料-收货人
        key: 'QSP_GET_CONSIGNEE_Ex_PAGE',
        pageDataKey: 'Table1',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/newCW_Detail/detail', // 财务中心-应收应付明细-现付
        key: 'YINGSHOUYINGFU_PAGE',
        pageDataKey: 'Rows',
        otherData: { xmtype: '现付' },
        otherDataKey: 'xmtype'
      },
      {
        path: '/newCW_Detail/detail', // 财务中心-应收应付明细-提付
        key: 'YINGSHOUYINGFU_PAGE',
        pageDataKey: 'Rows',
        otherData: { xmtype: '提付' },
        otherDataKey: 'xmtype'
      },
      {
        path: '/newCW_Detail/detail', // 财务中心-应收应付明细-回单月结
        key: 'YINGSHOUYINGFU_PAGE',
        pageDataKey: 'Rows',
        otherData: { xmtype: '回单月结' },
        otherDataKey: 'xmtype'
      },
      {
        path: '/AcceptanceOfBill/GridDPM', // 营运中心-导出多品名
        key: 'QSP_GET_TYD_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/reportTpl/getDataCommon', // 财务中心-网点出库报表
        key: 'QSP_OUT_RECORD_PAGE',
        pageDataKey: 'Rows',
        otherData: { type: '网点出库报表' },
        otherDataKey: 'type'
      },
      {
        path: '/customerPickUp/fETCH_LOAD', // 营运中心-客户提货-提货库存
        key: 'QSP_GET_FETCH_LOAD_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/CustomerPickUp/Index', // 营运中心-客户提货
        key: 'QSP_GET_FETCH_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/billing/cancelBillPost', // 财务中心-运单作废
        key: 'QSP_GET_TYD_ZUOFEI_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/financialReconciliation/customerReconciliation_Detailed', // 财务中心-客户对账-点击左侧客户加载右侧数据
        key: 'F9_QSP_CUSTOMER_COUNT_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: 'qsp_get_back_sign', // 回单管理-回单签收
        key: 'QSP_GET_BACK_SIGN_PAGE',
        pageDataKey: 'Table1',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: 'qsp_get_back_three', // 回单管理-回单返厂
        key: 'QSP_GET_BACK_THREE_PAGE',
        pageDataKey: 'Table1',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: 'qsp_get_back_two', // 回单管理-回单收到
        key: 'QSP_GET_BACK_TWO_PAGE',
        pageDataKey: 'Table1',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/webOrder/index', // 网络订单-列表提取
        key: 'O_QSP_GET_PARTORDER_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/outgoingRegistration/pollingTable', // 开派车单-提取
        key: 'QSP_GET_DUANTU_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/outgoingRegistration/getStock', // 派车单弹窗/尚有库存-提取
        key: 'QSP_GET_BATCHSETUNIT_LOAD_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/outgoingRegistration/gET_WILL_TPL_BILLNO', // 开派车单-关联运单弹窗
        key: 'QSP_GET_Will_TPL_BILLNO_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/acceptanceOfBill/index', // 受理开单-提取
        key: 'QSP_TYD_Ex_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/printbq/quickPrintbq', // 受理开单-快速打标-提取
        key: 'QSP_TYD_BIAOQIAN_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: '',
        dataIsArray: true
      },
      {
        path: '/fhkc/getData', // 发货库存-提取
        key: 'QSP_GET_LOCAL_REMAIN_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/shortHauls/shortHaulConnection', // 短途接驳 -提取
        key: 'QSP_GET_CONNECT_MAIN_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: '',
        dataIsArray: true
      },
      {
        path: '/shortHauls/newShortLighter', // 短途接驳-新增-提取
        key: 'QSP_GET_PACKAGE_LOAD_FOR_CONNECT_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: '',
        dataIsArray: true
      },
      {
        path: '/shortHauls/shorHaulsGetDataFromStock', // 短途接驳-短驳明细弹窗-尚有库存
        key: 'QSP_GET_PACKAGE_LOAD_FOR_CONNECT_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: '',
        dataIsArray: true
      },
      {
        path: '/fdpz/fdpzListQuery', // 分单配载-提取
        key: 'QSP_FCD_HT_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/fdpz/getStock', // 分单配载-配载清单-尚有库存
        key: 'QSP_GET_PACKAGE_LOAD_EX_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/fdpz/getFdpzYPZData', // 分单配载-预配载-提取
        key: 'QSP_GET_FCD_YPZ_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/ztgz/getZTGZRecords', // 车辆跟踪-提取
        key: 'QSP_FCD_HT_TRACE_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/outgoingRegistration/getTerminalData', // 本地代理-提取主记录
        key: 'QSP_GET_TYD_OUT_MAIN_PAGE',
        pageDataKey: 'Rows',
        otherData: { chooseState: '主记录' },
        otherDataKey: 'chooseState'
      },
      {
        path: '/outgoingRegistration/getTerminalData', // 本地代理-提取明细
        key: 'QSP_GET_TYD_OUT_LOCAL_PAGE',
        pageDataKey: 'Rows',
        otherData: { chooseState: '明细' },
        otherDataKey: 'chooseState'
      },
      {
        path: '/outgoingRegistration/getBatchMiddleYD', // 本地代理/单票中转-提取
        key: 'QSP_GET_PACKAGE_LOAD_OUT_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/outgoingRegistration/getMiddleOutStocks', // 本地代理/转送出库-提取
        key: 'QSP_GET_PACKAGE_LOAD_OUT_SH_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/outgoingRegistration/deliveryRecord', // 本地代理/出库记录
        key: 'QSP_GET_OUTSEND_MAIN_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/trackingInTransit/outsourcedGoods', // 货物跟踪-提取
        key: 'QSP_GET_TYD_OUT_TRACE_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/dhqr/getVehicles', // 到货确认-在途车辆-提取
        key: 'QSP_GET_INROAD_VEHICLE_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/dhqr/getArrivalVehicle', // 到货确认-到货车辆-提取
        key: 'QSP_GET_ARRIVED_VEHICLE_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/dhqr/getAllVehiclesInTransit', // 到货确认-所有在途车辆-提取
        key: 'QSP_GET_INROAD_VEHICLE_ALL_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/arrivalInventory/getgrid1Data', // 到货库存-提取
        key: 'QSP_GET_REMOTE_REMAIN_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/lastMileDelivery/deliveryStock', // 分离库存-提取（同 到货库存-提取）
        key: 'QSP_GET_REMOTE_REMAIN_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/arrivalInventory/getData_Json', // 到货库存-打印
        key: 'QSP_GET_REMOTE_REMAIN_PAGE',
        pageDataKey: 'Table',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/arrivalInventory/getgrid2Data', // 到货库存-到货记录-提取
        key: 'QSP_GET_ESITE_REMAIN_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/customerPickUp/fETCH_LOAD', // 客户提货/单票提货/取得库存
        key: 'QSP_GET_FETCH_LOAD_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/deliveryRecord/modifyGetinventory', // 送货上门-送货明细清单/尚有库存/取得库存
        key: 'QSP_GET_SEND_LOAD_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: 'qsp_get_send_load', // 送货上门-智能送货-提取
        key: 'QSP_GET_SEND_LOAD_PAGE',
        pageDataKey: 'Table1',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/outgoingRegistration/getTerminalData', // 终端代理-提取主记录
        key: 'QSP_GET_TYD_OUT_MAIN_PAGE',
        pageDataKey: 'Rows',
        otherData: { chooseState: '主记录' },
        otherDataKey: 'chooseState'
      },
      {
        path: '/outgoingRegistration/getTerminalData', // 终端代理-提取明细
        key: 'QSP_GET_TYD_OUT_LOCAL_PAGE',
        pageDataKey: 'Rows',
        otherData: { chooseState: '明细' },
        otherDataKey: 'chooseState'
      },
      {
        path: '/outgoingRegistration/getBatchMiddleYD', // 终端代理/单票中转
        key: 'QSP_GET_PACKAGE_LOAD_OUT_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/outgoingRegistration/getMiddleOutStocks', // 终端代理/转送出库-提取
        key: 'QSP_GET_PACKAGE_LOAD_OUT_SH_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/outgoingRegistration/deliveryRecord', // 终端代理/出库记录-提取
        key: 'QSP_GET_OUTSEND_MAIN_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/outgoingRegistration/getMiddleOutStocks', // 终端代理/出库记录/查看明细/尚有库存
        key: 'QSP_GET_PACKAGE_LOAD_OUT_SH_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/qsRegister/index', // 签收登记-提取
        key: 'QSP_GET_SEND_OUT_QS_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/qsRegister/getData_qsRegister', // 签收登记/单票签收/取得库存
        key: 'QSP_GET_SEND_OUT_QS_LOAD_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/home/dubanDetailData', // 我的主页/明细/现在_库存现金余额
        key: 'QSP_GET_COUNT_MONITOR_ACCACOUNT_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '现在_库存现金余额' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页/明细/送货未补充录入送货费票数
        key: 'QSP_GET_COUNT_MONITOR_ACCSEND_NOT_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '送货未补充录入送货费票数' },
        otherDataKey: 'name'
      },
      {
        path: '/billing/qSP_MONEY_GET_VERIFY', // 财务中心-财务工具-常用工具-运单审核
        key: 'QSP_MONEY_GET_VERIFY_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: '',
        dataIsArray: true
      },
      {
        path: '/sendPack_SB/sendOrders_SB', // 三包管理-三包配装-三包派单-提取
        key: 'PAIDANJILU_ANDAN_SB_PAGE',
        pageDataKey: 'Rows',
        otherData: { opertype: '0' },
        otherDataKey: 'opertype'
      },
      {
        path: '/pleaseInquire/pleaseInquire_Index', // 财务中心-财务做账-请款结果-提取
        key: 'F9_QSP_GET_QK_LIST_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/financialInstruments/getbillModifyRecord', // 财务中心-财务工具-常用工具-改单审批-提取
        key: 'QSP_GET_TYD_SUBMIT_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: 'qianshoujilu_sb', // 三包管理-三包配装-签收完成-提取
        key: 'QIANSHOUJILU_SB_PAGE',
        processCName: '签收记录_SB_PAGE',
        pageDataKey: 'Table1',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/outgoingRegistration/getTerminalDataFilter', // 营运中心-本地代理-选择类型主记录双击提取到的数据-代理主记录明细
        key: 'QSP_GET_TYD_OUT_MAIN_FILTER_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/home/dubanDetailData', // 我的主页/明细/现在_应收账款
        key: 'TJ_QSP_GET_EIGHT_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '现在_应收账款' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页/明细/改单比
        key: 'TJ_QSP_GET_SIX_DETAIL_1_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '改单比' },
        otherDataKey: 'name'
      },
      {
        path: '/deliveryRecord/index', // 营运中心-送货上门-提取
        key: 'QSP_GET_SEND_Ex_PAGE',
        pageDataKey: 'Rows',
        otherData: { opertype: '1' },
        otherDataKey: 'opertype'
      },
      {
        path: '/home/dubanDetailData', // 我的主页/明细/回单超期未收回
        key: 'TJ_QSP_GET_FIVE_DETAIL_1_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '回单超期未收回' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-督办-超过X天，未发车数
        key: 'TJ_QSP_GET_ONE_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '收货超期未发车' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-督办-发车超过X天，未做到货确认车数
        key: 'TJ_QSP_GET_TWO_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '发车超期未确认' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-督办-到货超过X天，直达未签收票数
        key: 'TJ_QSP_GET_THREE_DETAIL_1_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '到货超期直达未签收' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-督办-到货超过X天，中转未签收票数
        key: 'TJ_QSP_GET_THREE_DETAIL_2_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '到货超期中转未签收' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-督办-近X天内，异常回单笔数
        key: 'TJ_QSP_GET_FIVE_DETAIL_2_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '异常回单' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-财务-昨日（XXXX-XX-X）净产值总额
        key: 'TJ_QSP_GET_SIX_DETAIL_2_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '净产值' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-督办-截止目前，未回复问题件票数
        key: 'TJ_QSP_GET_SEVEN_DETAIL_1_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '问题件未回复' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-督办-截止目前，未被处理的理赔票数
        key: 'TJ_QSP_GET_SEVEN_DETAIL_2_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '理赔未定责' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-督办-截止目前，未被认领的无头件票数
        key: 'TJ_QSP_GET_SEVEN_DETAIL_3_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '无头件未认领' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-督办-截至目前，跟踪运单未结束票数
        key: 'QSP_GET_TICKETCOUNT_GZ_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '在途跟踪运单未跟踪结束票数' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-财务-截止目前，通过扫码支付票数
        key: 'QSP_GET_COUNT_MONITOR_MEMBERORDER_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '通过扫码支付票数' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-财务-截止目前，通过扫码支付总额
        key: 'QSP_GET_COUNT_MONITOR_MEMBERORDER_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '通过扫码支付总额' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-财务-签收超过X天，财务未做核销笔数
        key: 'TJ_QSP_GET_FOUR_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '签收超期未销账' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-财务-中转未补充录入中转费票数
        key: 'QSP_GET_COUNT_MONITOR_ACCZZ_NOT_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '中转未补充录入中转费票数' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-审批-改单未审批笔数
        key: 'QSP_GET_COUNT_MONITOR_TYDSUBMIT_NOT_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '改单未审批笔数' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-审批-有未审批请款笔数
        key: 'QSP_GET_COUNT_MONITOR_QKCHECK_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '有未审批请款笔数' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-审批-有未审批请款总额
        key: 'QSP_GET_COUNT_MONITOR_QKCHECK_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '有未审批请款总额' },
        otherDataKey: 'name'
      },
      // {
      //   path: '/home/dubanDetailData', // 我的主页-审批-回扣占比
      //   key: 'QSP_GET_COUNT_MONITOR_ACCHUIKOU_ZB_DETAIL_PAGE',
      //   pageDataKey: 'Rows',
      //   otherData: { name: '回扣占比' },
      //   otherDataKey: 'name'
      // },
      {
        path: '/home/dubanDetailData', // 我的主页-审批-发货库存
        key: 'QSP_GET_COUNT_MONITOR_BDKC_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '发货库存' },
        otherDataKey: 'name'
      },
      {
        path: '/home/dubanDetailData', // 我的主页-审批-到货库存
        key: 'QSP_GET_COUNT_MONITOR_DHKC_DETAIL_PAGE',
        pageDataKey: 'Rows',
        otherData: { name: '到货库存' },
        otherDataKey: 'name'
      },
      {
        path: '/forPayment/getNowaccData', // 财务中心/结款核销/送货费
        key: 'F9_QSP_GET_HX_LOAD_ACCSENDOUT_PAGE',
        pageDataKey: 'Rows',
        otherData: { type: '送货费' },
        otherDataKey: 'type'
      },
      {
        path: '/forPayment/getNowaccData', // 财务中心/结款核销/派车费
        key: 'F9_QSP_GET_HX_LOAD_ACCDUANTU_PAGE',
        pageDataKey: 'Rows',
        otherData: { type: '派车费' },
        otherDataKey: 'type'
      },
      {
        path: '/changeClassReport/getUnitChangeRecord', // 财务中心-报表中心-异常类-运单修改日报表-提取(修改)
        key: 'QSP_GET_MODIFIED_PAGE',
        pageDataKey: 'Rows',
        otherData: { SelectedIndex: '0' },
        otherDataKey: 'SelectedIndex'
      },
      {
        path: '/changeClassReport/getUnitChangeRecord', // 财务中心-报表中心-异常类-运单修改日报表-提取(删除)
        key: 'QSP_GET_MODIFIED_PAGE',
        pageDataKey: 'Rows',
        otherData: { SelectedIndex: '1' },
        otherDataKey: 'SelectedIndex'
      },
      {
        path: '/changeClassReport/getUnitChangeRecord', // 财务中心-报表中心-异常类-运单修改日报表-提取(修改+删除)
        key: 'QSP_GET_MODIFIED_PAGE',
        pageDataKey: 'Rows',
        otherData: { SelectedIndex: '2' },
        otherDataKey: 'SelectedIndex'
      },
      {
        path: '/changeClassReport/getUnitChangeRecord', // 财务中心-报表中心-异常类-运单修改日报表-提取(退货)
        key: 'QSP_GET_MODIFIED_PAGE',
        pageDataKey: 'Rows',
        otherData: { SelectedIndex: '4' },
        otherDataKey: 'SelectedIndex'
      },
      {
        path: '/billing/getShipperEsitePrice', // 定义公司-参数设置-开单设置-启用到站关联单价（勾选保存，重新登录，打开开单页）
        key: 'QSP_GET_SHIPPER_PRICE_ALL_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: '',
        dataIsArray: true
      },
      {
        path: '/billing/getConsigneeEsitePrice', // 定义公司-参数设置-开单设置-启用到站关联单价（勾选保存，重新登录，打开开单页）
        key: 'QSP_GET_CONSIGNEE_PRICE_ALL_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: '',
        dataIsArray: true
      },
      {
        path: '/baseSetting/selectVolumgesetupbysite', // 开单页-体积计算器
        key: 'QSP_GET_BYBSITE_VOLUMGESETUP_PAGE',
        pageDataKey: 'dtData',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/financialReconciliation/agentReconciliation_Detailed', // 财务中心-财务对账-代理对账-提取数据后双击左边的数据
        key: 'F9_QSP_CYGS_COUNT_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/forPayment/getNowaccData', // 财务中心-结款核销-货款发放-提取左边
        key: 'F9_QSP_GET_HX_LOAD_HKFF_PAGE',
        pageDataKey: 'Rows',
        otherData: { type: '货款发放' },
        otherDataKey: 'type'
      },
      {
        path: '/outbound/waybill/list', // 出库登记-提取
        key: 'IMPLICIT_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
      {
        path: '/outbound/waybill/pending/list', // 出库库存记
        key: 'IMPLICIT_PAGE',
        pageDataKey: 'Rows',
        otherData: {},
        otherDataKey: ''
      },
    ].forEach((item) => {
      item.path = item.path.toLowerCase()
      if (pagePortList[item.path]) {
        pagePortList[item.path].push(item)
      } else {
        pagePortList[item.path] = [item]
      }
    })
    ; (top as any).pagePortList = pagePortList
  console.log('初始化隐式分页配置')
}

window.$.getPagePortList()
